<template>
  <div class="app-wrapper bg-white h-100">
    <div class="app-main">
      <div class="app-content p-0">
        <div class="d-flex align-items-center">
          <div class="flex-grow-1 w-100 d-flex align-items-center">
            <div class="container-fluid">
              <div class="row" style="height: 100vh;">
                <div class="col-md-6 col-sm-0 background-image"></div>
                <div
                  class="col-md-6 d-flex justify-content-center align-self-center"
                >
                  <div
                    class="col-sm-10 mt-1 pt-0"
                    style="margin-left:auto;margin-right:auto;font-size:14px"
                  >
                    <h4 class="font-weight-bold">
                      Informasi umum Faskes
                    </h4>
                    <b-form-group novalidate="true" label-for="input-1">
                      <label class="font-weight-bold">Jenis Faskes</label>
                      <label style="color:red"> *</label>
                      <vue-select
                        v-model="jenis_faskes"
                        :options="[]"
                        disabled
                      />
                    </b-form-group>
                    <b-form-group novalidate="true" label-for="input-1">
                      <label class="font-weight-bold">Nama Faskes</label>
                      <b-form-input
                        v-model="nama_klinik"
                        maxlength="50"
                        disabled
                        id="input-1"
                        type="text"
                      >
                      </b-form-input>
                    </b-form-group>
                    <b-form-group label-for="input-1">
                      <label class="font-weight-bold" v-if="this.isDpm"
                        >Nama Lengkap</label
                      >
                      <label class="font-weight-bold" v-else>Nama PIC</label>
                      <label style="color:red"> *</label>
                      <b-form-input
                        v-model="nama_pic"
                        maxlength="50"
                        disabled
                        placeholder="Masukkan nama individu atau korporasi"
                        id="input-2"
                        type="text"
                      >
                      </b-form-input>
                      <template
                        v-if="
                          nama_pic === '' ||
                            (nama_pic === null && submitButton === true)
                        "
                      >
                        <label style="color: red">Kolom Harus Diisi</label>
                      </template>
                    </b-form-group>
                    <b-form-group
                      novalidate="true"
                      label-for="input-1"
                      :state="stateNoSIP"
                      v-if="isDpm"
                    >
                      <label class="font-weight-bold">No. SIP</label>
                      <label style="color:red"> *</label>
                      <b-form-input
                        v-model="ijin_nomor"
                        placeholder="Masukkan No. SIP"
                        id="input-3"
                        type="text"
                        :state="stateNoSIP"
                        @keypress.native="no_sip_touched = true"
                      >
                      </b-form-input>
                      <template #invalid-feedback>
                        <label style="color: red; font-size: 14px;">{{
                          invalidFeedbackNoSIP
                        }}</label>
                      </template>
                    </b-form-group>
                    <b-form-group novalidate="true" label-for="input-1" v-else>
                      <label class="font-weight-bold">No.izin Faskes</label>
                      <label style="color:red"> *</label>
                      <b-form-input
                        v-model="ijin_nomor"
                        maxlength="50"
                        disabled
                        placeholder="Masukkan No.izin Faskes"
                        id="input-3"
                        type="text"
                      >
                      </b-form-input>
                    </b-form-group>
                    <b-form-group v-if="isDpm">
                      <label class="font-weight-bold">Spesialisasi</label>
                      <label style="color:red"> *</label>
                      <vue-select
                        class="doctor_search"
                        v-model="spesialisasi"
                        :options="dataSpesialisasi"
                        placeholder="Pilih Spesialisasi"
                      />
                      <template
                        v-if="spesialisasi === null && submitButton === true"
                      >
                        <label style="color: red"
                          >Spesialisasi Harus Diisi</label
                        >
                      </template>
                    </b-form-group>
                    <div class="row">
                      <div class="col-lg-12" v-if="!isDpm">
                        <b-form-group novalidate="true" label-for="input-1">
                          <label class="font-weight-bold">Jenis Klinik</label>
                          <label style="color:red"> *</label>
                          <vue-select
                            v-model="tipe_faskes"
                            :options="dataJenisKlinik"
                            disabled
                          />
                          <template
                            v-if="tipe_faskes === null && submitButton === true"
                          >
                            <label style="color: red">Kolom Harus Diisi</label>
                          </template>
                        </b-form-group>
                      </div>
                    </div>
                    <b-form-group :state="stateNoTelp">
                      <label class="font-weight-bold">No. Telp Faskes</label>
                      <label style="color:red"> *</label>
                      <b-form-input
                        v-model="no_telp"
                        maxlength="15"
                        placeholder="Masukkan No. Telp Faskes"
                        id="input-no-telp"
                        type="text"
                        @keypress.native="
                          numberOnly($event);
                          no_telp_touched = true;
                        "
                        :state="stateNoTelp"
                      >
                      </b-form-input>
                      <template #invalid-feedback>
                        <label style="color: red; font-size: 14px;">{{
                          invalidFeedbackNoTelp
                        }}</label>
                      </template>
                    </b-form-group>
                    <b-form-group :state="stateNoWA">
                      <label class="font-weight-bold"
                        >No. Whatsapp Faskes</label
                      >
                      <b-form-input
                        v-model="no_wa"
                        maxlength="15"
                        placeholder="Masukkan No. Whatsapp Faskes"
                        id="input-no-wa"
                        type="text"
                        @keypress.native="numberOnly"
                        :state="stateNoWA"
                      >
                      </b-form-input>
                      <template #invalid-feedback>
                        <label style="color: red; font-size: 14px;">{{
                          invalidFeedbackNoWA
                        }}</label>
                      </template>
                    </b-form-group>
                    <div class="row">
                      <div class="col-lg-12">
                        <b-form-group novalidate="true" label-for="input-1">
                          <label class="font-weight-bold">Kab/Kota</label>
                          <label style="color:red"> *</label>
                          <vue-select
                            v-model="kota"
                            :options="dataKota"
                            :disabled="!isDpm"
                            :value="kota"
                            placeholder="Pilih Kota"
                            class="doctor_search"
                          />
                          <template
                            v-if="kota === null && submitButton === true"
                          >
                            <label style="color: red"
                              >Kab/Kota Harus Diisi</label
                            >
                          </template>
                        </b-form-group>
                      </div>
                    </div>
                    <b-form-group novalidate="true" label-for="input-1">
                      <label class="font-weight-bold">Alamat</label>
                      <label style="color:red"> *</label>
                      <b-form-textarea
                        v-model="alamat"
                        placeholder="Masukkan Alamat"
                        id="input-3"
                        rows="3"
                        max-rows="6"
                        maxlength="150"
                      >
                      </b-form-textarea>
                      <template
                        v-if="
                          alamat === '' ||
                            (alamat === null && submitButton === true)
                        "
                      >
                        <label style="color: red">Alamat Harus Diisi</label>
                      </template>
                    </b-form-group>
                    <button
                      type="submit"
                      @click="updateKlinik"
                      class="btn btn-md btn-block text-capitalize mb-2"
                      style="background-color :#3F7EA7; color:white; border-radius : 10px;"
                    >
                      SELESAI
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapMutations, mapGetters } from "vuex";

export default {
  components: {
    "vue-select": () => import("@/components/VueSelectClearable.vue")
  },
  data() {
    return {
      no_sip_touched: false,
      spesialisasi: null,
      dataSpesialisasi: [],
      no_telp: null,
      no_wa: null,
      no_telp_touched: false,
      jenis_faskes: null,
      isDpm: false,
      windowHeight: 0,
      submitButton: false,
      dataKlinik: [],
      dataJenisKlinik: [],
      dataKota: [],
      optionJumlah: [
        {
          label: "0 - 3 dokter",
          value: 1
        },
        {
          label: "3- 5 dokter",
          value: 2
        },
        {
          label: "5 - 10 dokter",
          value: 3
        },
        {
          label: "> dari 10 dokter",
          value: 4
        }
      ],
      nama_pic: null,
      ijin_nomor: null,
      tipe_faskes: null,
      jumlah_dokter: null,
      alamat: null,
      kota: null,
      nama_klinik: null
    };
  },
  mounted() {
    if (localStorage.getItem("klinik") == "false") {
      this.$router.push(`/`);
    }
    this.getSpesialisasi();
    this.getKota();
    this.dataUser();
    this.windowHeight = window.innerHeight;
    this.$nextTick(() => {
      window.addEventListener("resize", e => {
        this.windowHeight = window.innerHeight;
      });
    });
  },
  computed: {
    stateNoWA() {
      if (this.no_wa == null || this.no_wa == "") {
        return true;
      }

      if (this.no_wa.length < 9) {
        return false;
      }

      return true;
    },
    invalidFeedbackNoWA() {
      if (this.no_wa && this.no_wa.length < 9) {
        return "No. Whatsapp Faskes Minimal 9 Karakter";
      }

      return "";
    },
    stateNoTelp() {
      if (!this.no_telp_touched) {
        return null;
      }

      if (this.no_telp == null) {
        return false;
      }

      if (this.no_telp.length < 9) {
        return false;
      }

      return this.no_telp != "";
    },
    invalidFeedbackNoTelp() {
      if (this.no_telp == null || this.no_telp == "") {
        return "No. Telp Faskes Harus Diisi";
      }

      if (this.no_telp.length < 9) {
        return "No. Telp Faskes Minimal 9 Karakter ";
      }

      return "Please enter something.";
    },
    stateNoSIP() {
      if (!this.no_sip_touched) {
        return null;
      }
      if (this.ijin_nomor == null || this.ijin_nomor == "") {
        return false;
      }

      return true;
    },
    invalidFeedbackNoSIP() {
      if (this.ijin_nomor == null || this.ijin_nomor == "") {
        return "No. SIP Harus Diisi";
      }

      return "Please enter something.";
    },
    wrapStyle() {
      return {
        height: this.windowHeight + "px"
      };
    },
    wrapImgStyle() {
      return {
        "max-height": this.windowHeight + "px"
      };
    },
    ...mapGetters({
      klinikUser: "klinikUser"
    }),
    windowWidth() {
      return window.innerWidth > 770 ? true : false;
    }
  },
  watch: {},
  methods: {
    async getSpesialisasi() {
      try {
        const res = await this.$axios.get(`spesialisasi`);
        const { data } = res.data;
        this.dataSpesialisasi = data.spesialisasi.map(item => {
          return {
            id: item.id,
            label: item.nama
          };
        });
      } catch (error) {}
    },
    async getKota() {
      try {
        const res = await this.$axios.get(`getcity`);
        const { data } = res.data;
        this.dataKota = data.map(item => {
          return {
            id: item.id,
            label: item.nama
          };
        });
      } catch (error) {}
    },
    numberOnly(event) {
      const key = String.fromCharCode(event.keyCode);
      if (!/^\d+$/.test(key)) {
        event.preventDefault();
      }
    },
    ...mapMutations({
      collapseSidebar: "sidebar/SET_SIDEBAR_COLLAPSED",
      setInitPage: "sidebar/SET_INITIALIZATION_PAGE",
      setUserFirstLogin: "SET_USER_FIRST_LOGIN",
      setInitPosition: "SET_INIT_POSITION"
    }),
    async dataUser() {
      try {
        const res = await this.$axios.get(
          `klinik/pic/inisiasi?user_id=${this.$store.state.user.id}`
        );
        const { data } = res.data;

        this.dataKlinik = data.klinik;
        this.nama_klinik = this.dataKlinik.nama_klinik;
        this.nama_pic = this.dataKlinik.nama_pic;
        this.ijin_nomor = this.dataKlinik.nomor_ijin;
        this.tipe_faskes = this.dataKlinik.faskes.name;

        if (this.dataKlinik.kota.id != null) {
          this.kota = {
            id: this.dataKlinik.kota.id,
            label: this.dataKlinik.kota.nama
          };
        }

        this.isDpm = data.is_dpm ? true : false;
        this.jenis_faskes = this.isDpm ? "Dokter Praktik Mandiri" : "Klinik";
      } catch {}
    },
    async updateKlinik() {
      this.submitButton = true;
      this.no_telp_touched = true;
      this.no_sip_touched = true;

      if (
        !this.stateNoTelp ||
        !this.stateNoWA ||
        this.alamat == null ||
        this.alamat == ""
      ) {
        return;
      }

      if (
        this.isDpm &&
        (!this.stateNoSIP ||
          this.spesialisasi == null ||
          this.spesialisasi == "" ||
          this.kota == null ||
          this.kota == "")
      ) {
        return;
      }

      try {
        let paramPut = {
          nama_pic: this.nama_pic,
          nomor_ijin: this.ijin_nomor,
          tipe_faskes: this.dataKlinik.faskes.id,
          alamat: this.alamat,
          no_telp: this.no_telp,
          no_wa: this.no_wa
        };

        let url = `klinik/${this.dataKlinik.id}`;

        if (this.isDpm) {
          paramPut = {
            ...paramPut,
            spesialisasi_id: this.spesialisasi.id,
            kota: this.kota.id,
            user_id: this.$store.state.user.id
          };

          url = `klinik/dpm/${this.dataKlinik.id}`;
        }

        const res = await this.$axios.put(url, paramPut);
        const { status } = res.data;

        if (status) {
          this.$axios
            .get(`user/finish?klinik_id=${this.dataKlinik.id}`)
            .then(res => {
              localStorage.setItem("klinik", false);

              this.setInitPage(false);
              this.setUserFirstLogin(0);

              if (this.klinikUser.length > 1) {
                this.$router.push({
                  name: "change-klinik"
                });
              } else {
                this.$router.push({
                  name: "home"
                });
              }
            });
        }
      } catch (err) {
        // console.log(err);
      }
    }
  }
};
</script>

<style scoped>
.background-image {
  background-image: url("./../../assets/img/inisiasi.jpg");
  background-size: cover; /* Cover the entire div with the background image */
  background-position: center; /* Center the background image */
}
.content-register-right {
  position: absolute;
  right: 0px;
  zoom: 83%;
}

.img-banner-left {
  position: fixed;
}

.wrap {
  width: 100%;
  height: 100%;
  position: relative;
  display: inline-block;
  overflow: hidden;
  margin: 0;
}

.wrap img {
  display: block;
  position: absolute;
  top: 50%;
  left: 50%;
  min-height: 100%;
  min-width: 100%;
  transform: translate(-50%, -50%);
}
</style>

<style>
.doctor_search
  .vs__dropdown-toggle
  .vs__selected-options
  .vs__search::placeholder {
  color: #d1d2db !important;
}
</style>
